import React from "react";
import PropTypes from "prop-types";
import DcOverviewtable from "./DcOverviewtable";

const DcSupplyInsightsOverviewTable = ({
  data,
  columns,
  paginationData,
  sortingData,
  handlePageChange,
  isLoading = false,
  activeTab,
}) => {
  let scrollableColumnsArray = [];

  if (activeTab === "Summary") {
    scrollableColumnsArray = [
      "Order Loss Volume",
      "Order Loss Value",
      "Order Loss NR Sufficiency",
      "NR Propogation Loss",
      "Net Requirements",
      "Allocation",
      "PDQ",
      "NR Loss Component %",
      "NR Loss Component (Volume)"
    ];
  } else if (activeTab === "Order Loss NR Sufficiency") {
    scrollableColumnsArray = [
      "Order Loss Post PDQ",
      "NR At Dest",
      "Order Loss Vs NR Final",
      "Norm Days",
    ];
  } else if (activeTab === "NR Propogation Loss") {
    scrollableColumnsArray = [
      "NR APO",
      "Order Loss Post PDQ",
      "NR At Dest",
      "NR At Dest Vs NR APO Drop",
      "Stamping In Volume",
      "Stamping (Yes or No)",
    ];
  } else if (activeTab === "NR - Alloc % Drop") {
    scrollableColumnsArray = [
      "NR APO",
      "Alloc at Source",
      "NR APO vs Alloc at Source",
      "QC Cleared Stock",
      "Reservation Stock",
      "Stock not available (prod plan not done / booking pending)",
      "QC Cleared Loss",
      "Reservation Loss",
      "Open PO Loss",
      "IC Master",
      "Addition of indent loss tree from midfile",
    ];
  } else if (activeTab === "Alloc to PDQ") {
    scrollableColumnsArray = [
      "NR APO",
      "Alloc at Source",
      "PDQ",
      "Loss % (alloc - pdq)/ NR APO",
      "Losses %",
      "PDQ Indent",
      "Addition of indent loss tree from F2DC",
    ];
  }

  return (
    <DcOverviewtable
      data={data}
      columns={columns}
      paginationData={paginationData}
      sortingData={sortingData}
      handlePageChange={handlePageChange}
      isLoading={isLoading}
      scrollableColumnsArray={scrollableColumnsArray}
      fixedColumnName={columns?.[0]?.label}
      totalColumnName={columns?.[0]?.label}
      tableType="Smart Source Lens"
    />
  );
};

DcSupplyInsightsOverviewTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    }),
  ),
  paginationData: PropTypes.shape({
    page: PropTypes.number,
    pageSize: PropTypes.number,
    totalRecords: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  sortingData: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  handlePageChange: PropTypes.func,
  isLoading: PropTypes.bool,
  activeTab: PropTypes.string,
};

DcSupplyInsightsOverviewTable.defaultProps = {
  data: [],
  columns: [],
  paginationData: {},
  sortingData: {},
  handlePageChange: () => {},
  isLoading: false,
  activeTab: "",
};

export default DcSupplyInsightsOverviewTable;
